import React, { useState, useEffect, useRef } from 'react';
import { useAuthenticator, withAuthenticator } from '@aws-amplify/ui-react';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { generateClient } from "aws-amplify/api";
import { createTestExecution } from '../graphql/mutations';
import { View, Flex, Text, Heading, Button, ThemeProvider, Grid, Alert, CheckboxField } from "@aws-amplify/ui-react";
import Question from './Question';
import Progress from './Progress';
import Results from './Results';
import { TestExecutionStatus } from '../models';

const client = generateClient();



const theme = {
  // Define your theme here
};

const Quiz = ({ test, testExecution }) => {
  console.log("test received on quiz" + JSON.stringify(test));
  console.log("testExecution received on quiz" + JSON.stringify(testExecution));
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);

  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [attributes, setAttributes] = useState({});


  const { user } = useAuthenticator((context) => [context.user]);
  const [remainingTime, setRemainingTime] = useState(test?.durationInMinutes * 60 || 0);
  const [showAlert, setShowAlert] = useState(false);
  const [checked, setChecked] = useState(false);
  const timerRef = useRef(null);

  const updateProgress = (activeIndex) => {
    const buttons = document.querySelectorAll('.progress-button');
    buttons.forEach((button, index) => {
      button.classList.remove('active', 'answered', 'unanswered', 'correct', 'incorrect');
      if (quizSubmitted) {
        if (answers[index] === questions[index].correct_answer) {
          button.classList.add('correct');
        } else {
          button.classList.add('incorrect');
        }
      } else {
        if (answers[index] !== undefined) {
          button.classList.add('answered');
        } else {
          button.classList.add('unanswered');
        }
      }
      if (index === activeIndex) {
        button.classList.add('active');
      }
    });
  };

  useEffect(() => {
    async function fetchUserDetails() {
      try {
        const attributes = await fetchUserAttributes();
        setAttributes(attributes);
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    }
    fetchUserDetails();
  }, [user]);

  useEffect(() => {
    if (testExecution) {
      setQuizSubmitted(true);
      // alert("testExecution ... : " + JSON.stringify(testExecution.test.TestExecutions.items));
      // alert("answers ..  : " + testExecution.answers);
      console.log("testExecution answers..... : " + JSON.stringify(testExecution.answers));

      setAnswers(testExecution.answers);
    }
  }, [testExecution]);

  useEffect(() => {
    if (test && test.questions) {
      const transformedData = test.questions.map(question => ({
        ...question,
        possible_answers: question.possible_answers.map(answer => answer.possibleAnswer)
      }));
      setQuestions(transformedData);

      console.log("answers XX : " + JSON.stringify(answers));

      // setAnswers(new Array(transformedData.length).fill(undefined));
      if (!testExecution) {
        setAnswers(new Array(transformedData.length).fill(undefined));
      }
    }
  }, [test]);

  useEffect(() => {
    updateProgress(currentQuestionIndex);
  }, [currentQuestionIndex, answers, quizSubmitted]);

  useEffect(() => {
    if (remainingTime > 0 && !quizSubmitted) {
      timerRef.current = setInterval(() => {
        setRemainingTime(prevTime => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerRef.current);
    } else {
      clearInterval(timerRef.current);
    }
  }, [remainingTime, quizSubmitted]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!quizSubmitted) {
        if (event.key === 'ArrowLeft') {
          prevQuestion();
        } else if (event.key === 'ArrowRight') {
          nextQuestion();
        } else if (event.key === 'Enter') {
          nextQuestion();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentQuestionIndex, quizSubmitted]);

  const handleAnswer = (index, answer) => {
    const newAnswers = [...answers];
    newAnswers[index] = answer;
    setAnswers(newAnswers);
  };

  const nextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      document.activeElement.blur();
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      scrollToQuestion(currentQuestionIndex + 1);
    }
  };

  const prevQuestion = () => {
    if (currentQuestionIndex > 0) {
      document.activeElement.blur();
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      scrollToQuestion(currentQuestionIndex - 1);
    }
  };

  const submitQuiz = async () => {
    if (quizSubmitted) return;
    if (testExecution?.status === TestExecutionStatus.SUBMITTED) return;
    clearInterval(timerRef.current);
    if (answers.includes(undefined) && !checked) {
      setShowAlert(true);
      return;
    }
    setQuizSubmitted(true);
    updateProgress(currentQuestionIndex);

    const score = answers.reduce((acc, answer, index) => {
      return acc + (answer === questions[index].correct_answer ? 1 : 0);
    }, 0);

    const datetime = new Date().toISOString();
    const durationMinutes = (test?.durationInMinutes * 60 - remainingTime) / 60;
    setShowAlert(false);

    try {
      await client.graphql({
        query: createTestExecution,
        variables: {
          input: {
            score: score,
            answers: answers,
            TestExecutionStatus: TestExecutionStatus.SUBMITTED,
            studentId: user.username,
            testID: test.id,
            durationMinutes: durationMinutes,
          }
        }
      });
    } catch (error) {
      console.log('Error saving TestExecution:', error);
    }

    // const result = {
    //   score: score,
    //   datetime: datetime,
    //   student: {
    //     cognitoId: user.username,
    //     givenName: attributes.given_name,
    //     familyName: attributes.family_name
    //   },
    //   answers: answers
    // };
    //
    // console.log(JSON.stringify(result, null, 2));
  };

  const handleProgressClick = (index) => {
    setCurrentQuestionIndex(index);
    scrollToQuestion(index);
  };

  const scrollToQuestion = (index) => {
    const questionElement = document.getElementById(`question-${index}`);
    if (questionElement) {
      questionElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderAlert = () => {
    if (showAlert) {
      return (
          <View>
            <Alert
                variation="warning"
                isDismissible={false}
                hasIcon={true}
                heading="Incomplete Quiz"
            >
              Please answer all questions before submitting the quiz.
            </Alert>
            <CheckboxField
                label="Submit Quiz with unanswered questions"
                name="subscribe"
                value="yes"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
            ></CheckboxField>
          </View>
      );
    }
    return null;
  };

  return (
      <ThemeProvider theme={theme}>
      <View marginTop="large" marginInline="auto" padding="large" className="quiz-container">
          {renderAlert()}
          <Grid columnGap="0.5rem" rowGap="0.5rem" templateColumns="1fr 2fr 2fr 1fr">
          <View marginTop="large" marginInline="auto" padding="large" columnStart="1" columnEnd="-1">
            <Heading level={2} color="green">
                {attributes.given_name && attributes.family_name ? (
                    <p>Welcome, {attributes.given_name} {attributes.family_name}!</p>
                ) : (
                    <p>Loading user information...</p>
                )}
              </Heading>
            <Heading level={1} color="green">{test?.name ? test.name : "Quiz"}</Heading>
              {quizSubmitted && (
                  <Text>Duration: {test?.durationInMinutes} minutes</Text>
              )}
              {!quizSubmitted && (
                  <Text>Time Remaining: {formatTime(remainingTime)}</Text>
              )}
            </View>
            <View columnStart="1" columnEnd="4">
              {!quizSubmitted && (
              <Flex padding="large" gap="2rem" className="quiz-navigation">
                    <Button
                        onClick={prevQuestion}
                        disabled={currentQuestionIndex === 0}
                        variation={"primary"}
                    >
                      Précédente
                    </Button>
                    <Button
                        onClick={nextQuestion}
                        disabled={currentQuestionIndex === questions.length - 1}
                        variation={"primary"}
                    >
                      Suivante
                    </Button>
                    <Button
                        onClick={submitQuiz}
                        variation={"primary"}
                    >Terminer le test</Button>
                  </Flex>
              )}
              {quizSubmitted ? (
                  <Results questions={questions} answers={answers} />
              ) : (
                  <>
                    {questions.length > 0 && (
                        <Question
                            question={questions[currentQuestionIndex]}
                            index={currentQuestionIndex}
                            handleAnswer={handleAnswer}
                            answers={answers}
                        />
                    )}
                  </>
              )}
            </View>
            <View columnStart="4" columnEnd="-1">
              <Progress
                  questions={questions}
                  currentQuestionIndex={currentQuestionIndex}
                  setCurrentQuestionIndex={handleProgressClick}
                  answers={answers}
              />
            </View>
          </Grid>
        </View>
      </ThemeProvider>
  );
};

export default withAuthenticator(Quiz, {
  includeGreetings: true,
  formFields: {
    signUp: {
      email: { isRequired: true },
      family_name: { isRequired: true },
      given_name: { isRequired: true },
    }
  }
});